import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Box, Typography, CircularProgress, Paper } from '@mui/material';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import analyticsService from '../services/analyticsService';

// Registrar los componentes necesarios de Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const RevenueChart = ({ filters }) => {
  const [loading, setLoading] = useState(true);
  const [revenueData, setRevenueData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await analyticsService.getRevenueByPeriod(filters);
        setRevenueData(data);
        setError(null);
      } catch (err) {
        console.error('Error al obtener datos de ingresos:', err);
        setError('No se pudieron cargar los datos de ingresos');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [filters]);

  const chartData = {
    labels: revenueData.map(item => item.period),
    datasets: [
      {
        label: 'Ingresos por comisiones',
        data: revenueData.map(item => item.total_revenue),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
        borderColor: 'rgb(53, 162, 235)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: `Ingresos por Comisiones (${filters.periodType === 'monthly' ? 'Mensual' : 'Trimestral'})`,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat('es-PE', { 
                style: 'currency', 
                currency: 'PEN' 
              }).format(context.parsed.y);
            }
            return label;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return new Intl.NumberFormat('es-PE', { 
              style: 'currency', 
              currency: 'PEN',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value);
          }
        }
      }
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" gutterBottom>
        Ingresos por Comisiones
      </Typography>
      <Box sx={{ height: 400, position: 'relative' }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : revenueData.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography>No hay datos disponibles para el período seleccionado</Typography>
          </Box>
        ) : (
          <Bar data={chartData} options={options} />
        )}
      </Box>
    </Paper>
  );
};

export default RevenueChart;
